import { render } from "./MultiActionButton.vue?vue&type=template&id=45e204b7&scoped=true"
import script from "./MultiActionButton.vue?vue&type=script&lang=js"
export * from "./MultiActionButton.vue?vue&type=script&lang=js"

import "./MultiActionButton.vue?vue&type=style&index=0&id=45e204b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e204b7"]])

export default __exports__